import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import { getAuthToken, getCsrfToken } from "utils/cookies";

const fetchBaseQueryWithAuth = fetchBaseQuery({
  baseUrl: import.meta.env.VITE_DJANGO_ENDPOINT || "http://localhost:8000/api/",
  credentials: "include",
  prepareHeaders(headers) {
    const authToken = getAuthToken();
    const csrfToken = getCsrfToken();

    if (authToken) {
      headers.set("Authorization", `Token ${authToken}`);
    }

    if (csrfToken) {
      headers.set("X-CSRFToken", csrfToken);
    }

    return headers;
  },
});

// Define a service using a base URL and expected endpoints
export const baseApi = createApi({
  reducerPath: "niapApi",
  // baseUrl is used by default for all requests
  baseQuery: fetchBaseQueryWithAuth,
  endpoints: () => ({}), // We will populate these elsewhere
  tagTypes: [
    "ASSOCIATED_PRODUCTS",
    "ASSURANCE_MAINTENANCE",
    "CONTACT_CATEGORIES",
    "EARS",
    "ECR_COMMENTS",
    "ECR_DOCS",
    "ECR_NOTES",
    "ECR_TDS",
    "ECR_TQS",
    "ECR",
    "EXPANDED_ECR_ASSIGNMENT",
    "FEATURES",
    "FILE",
    "FILES",
    "LAI_VALIDATION_DATES",
    "FOLDERS",
    "MAIL_CATEGORIES",
    "MAIL_CONFIG",
    "MAIL_LISTS",
    "MAIL_LIST_USERS",
    "MAIL_USERS",
    "MAIL_USER_LISTS",
    "MAINTENANCE_BANNER",
    "MY_ORG",
    "NIST_COMMENTS",
    "NIST_HISTORY",
    "NIST",
    "NOTE",
    "ORG_DOCS",
    "POLICIES",
    "PRODUCTS",
    "PRODUCT_FEATURES",
    "PRODUCT_UPDATES",
    "PROFICIENCY_FEEDBACK",
    "QA_TICKETS",
    "REPORTS",
    "TD_VOTES",
    "TECH_COMMUNITIES",
    "TQ_VOTES",
  ], // If you add a new cache tag you need to add it here first before you can use it
});
